import React, { useEffect, useState } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";

function TagSelector({
  title = "تگ‌ها",
  options = [],
  defaultValue = [],
  onChange,
  className = "",
}) {
  const [tagOptions, setTagOptions] = useState(options);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setTagOptions(options);
  }, [options]);

  useEffect(() => {
    setValue(defaultValue || []);
  }, [defaultValue]);

  return (
    <div className={className} style={{ marginRight: "1rem", width: "100%" }}>
      <Autocomplete
        multiple
        freeSolo
        options={tagOptions}
        value={value}
        onChange={(event, newValue) => {
          // حذف تگ‌های تکراری
          const tags = [...new Set(newValue.map((item) => item.trim()))].filter(
            Boolean,
          );

          // اضافه شدن تگ‌های جدید به لیست پیشنهادها
          setTagOptions((prev) => [
            ...prev,
            ...tags.filter((tag) => !prev.includes(tag)),
          ]);

          setValue(tags);
          onChange && onChange(tags);
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="filled"
              label={option}
              {...getTagProps({ index })}
              key={option}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label={title}
            placeholder="تگ را وارد کنید و Enter بزنید"
          />
        )}
      />
    </div>
  );
}

export default TagSelector;
